export default {"src":"/_next/static/media/mailResponseAnimation.d4ad1f5f.gif","height":474,"width":480};